(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bn-benefits-slider"] && !Shopify.designMode) return;
  try {
    
/* BN - Benefits Slider: loops at both ends. Desktop plays the Figma card-stack motion (CSS), mobile fades.
   Arrows, dots and swipe all go through goTo(). */
(function () {
  function init(root) {
    if (root.dataset.mxBsReady) return;
    root.dataset.mxBsReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mx-bs-slide]'));
    var glows = Array.prototype.slice.call(root.querySelectorAll('[data-mx-bs-glow]'));
    var n = slides.length;
    if (!n) return;
    var active = 0;
    var DURATION = 1300;
    var settleTimer = null;
    var mod = function (i) { return (i % n + n) % n; };

    function setState(slide, state, instant) {
      if (instant) slide.classList.add('no-anim');
      slide.classList.remove('is-active', 'is-next', 'is-leaving');
      if (state) slide.classList.add(state);
      if (instant) {
        void slide.offsetWidth;
        slide.classList.remove('no-anim');
      }
    }

    function goTo(index, dir) {
      var target = mod(index);
      var previous = active;
      if (!dir) dir = target >= previous ? 1 : -1;
      active = target;

      if (target !== previous) {
        if (dir > 0) {
          /* Next: current card sinks down, target comes forward */
          setState(slides[previous], 'is-leaving');
          setState(slides[target], 'is-active');
        } else {
          /* Prev: target rises from below, current card goes back behind */
          setState(slides[target], 'is-leaving', true);
          setState(slides[target], 'is-active');
          setState(slides[previous], 'is-next');
        }
      }

      var next = mod(target + 1);
      slides.forEach(function (slide, i) {
        if (i === target || (i === previous && target !== previous)) return;
        setState(slide, i === next && n > 1 ? 'is-next' : null);
      });

      /* After the motion, the card that left moves (invisibly) back into the stack */
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        slides.forEach(function (slide, i) {
          if (!slide.classList.contains('is-leaving')) return;
          setState(slide, null, true);
          if (i === mod(active + 1) && n > 1) setState(slide, 'is-next');
        });
      }, DURATION + 50);

      slides.forEach(function (slide, i) {
        var on = i === active;
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        slide.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      });
      glows.forEach(function (glow, i) {
        glow.classList.toggle('is-active', i === active);
      });
    }

    root.querySelectorAll('[data-mx-bs-prev]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(active - 1, -1); });
    });
    root.querySelectorAll('[data-mx-bs-next]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(active + 1, 1); });
    });
    root.querySelectorAll('[data-mx-bs-dot]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(parseInt(b.getAttribute('data-mx-bs-dot'), 10)); });
    });

    var card = root.querySelector('[data-mx-bs-card]');
    var startX = null;
    var startY = null;
    card.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    card.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goTo(dx < 0 ? active + 1 : active - 1, dx < 0 ? 1 : -1);
      startX = null;
    }, { passive: true });

    /* Initial stack without animation: first card in front, second behind */
    slides.forEach(function (slide, i) { setState(slide, i === 0 ? 'is-active' : (i === 1 ? 'is-next' : null), true); });
    goTo(0, 1);

    /*
      Auto change (section settings): keeps running on hover and touch (client, 2026-10-05); it only
      waits while the section is off screen or the tab is hidden, so a visitor never misses a slide.
    */
    var interval = parseFloat(root.getAttribute('data-mx-bs-interval')) || 0;
    var autoplay = root.getAttribute('data-mx-bs-autoplay') === 'true' && interval > 0 && slides.length > 1 &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (autoplay) {
      var timer = null;
      var onScreen = true;
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() {
        stop();
        if (!onScreen || document.hidden) return;
        timer = setInterval(function () { goTo(active + 1, 1); }, interval * 1000);
      }
      /* An arrow / dot click, a swipe or a keypress restarts the wait from now */
      ['click', 'touchend', 'keyup'].forEach(function (type) {
        root.addEventListener(type, play);
      });
      document.addEventListener('visibilitychange', play);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
          play();
        }, { threshold: 0.2 }).observe(root);
      } else {
        play();
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mx-bs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-bs]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-clinical-results"] && !Shopify.designMode) return;
  try {
    
/* BN - Clinical Results: draggable before/after divider + PDF download */
(function () {
  function init(root) {
    if (root.dataset.mxCrReady) return;
    root.dataset.mxCrReady = 'true';

    var compare = root.querySelector('[data-mx-cr-compare]');
    var handle = root.querySelector('[data-mx-cr-handle]');
    if (compare && handle) {
      var pos = 50;
      var dragging = false;

      var beforeLabel = root.querySelector('.mx-cr__label--before');
      var afterPill = root.querySelector('.mx-cr__after-pill');

      function setPos(value) {
        pos = Math.max(0, Math.min(100, value));
        compare.style.setProperty('--pos', pos + '%');
        handle.setAttribute('aria-valuenow', Math.round(pos));

        /* Show a label only while its own photo is visible under it */
        var box = compare.getBoundingClientRect();
        var divider = box.left + (box.width * pos) / 100;
        if (beforeLabel) {
          beforeLabel.classList.toggle('is-hidden', divider < beforeLabel.getBoundingClientRect().right);
        }
        if (afterPill) {
          afterPill.classList.toggle('is-hidden', divider > afterPill.getBoundingClientRect().left);
        }
      }

      function fromEvent(e) {
        var rect = compare.getBoundingClientRect();
        setPos(((e.clientX - rect.left) / rect.width) * 100);
      }

      compare.addEventListener('pointerdown', function (e) {
        dragging = true;
        fromEvent(e);
        if (e.pointerType === 'mouse') compare.setPointerCapture(e.pointerId);
      });
      compare.addEventListener('pointermove', function (e) {
        if (dragging) fromEvent(e);
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
        compare.addEventListener(type, function () { dragging = false; });
      });

      /* Touch: follow horizontal swipes, leave vertical scrolling to the page */
      var startX = null;
      var startY = null;
      var horizontal = false;
      compare.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        horizontal = false;
      }, { passive: true });
      compare.addEventListener('touchmove', function (e) {
        if (startX === null) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (!horizontal && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 4) horizontal = true;
        if (horizontal) fromEvent(e.touches[0]);
      }, { passive: true });
      compare.addEventListener('touchend', function () { startX = null; }, { passive: true });

      handle.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { setPos(pos - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPos(pos + 5); e.preventDefault(); }
      });
    }

    /* The report lives on cdn.shopify.com (another origin), where the download attribute is ignored,
       so fetch it and save it as a file. Falls back to opening the PDF in a new tab. */
    var download = root.querySelector('[data-mx-cr-download]');
    if (download) {
      download.addEventListener('click', function (e) {
        if (!window.fetch || !window.URL || !URL.createObjectURL) return;
        e.preventDefault();
        var url = download.href;
        fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error(res.status);
            return res.blob();
          })
          .then(function (blob) {
            var link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = download.getAttribute('download') || 'report.pdf';
            document.body.appendChild(link);
            link.click();
            setTimeout(function () {
              URL.revokeObjectURL(link.href);
              link.remove();
            }, 1000);
          })
          .catch(function () {
            window.open(url, '_blank', 'noopener');
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mx-cr]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-cr]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-faq"] && !Shopify.designMode) return;
  try {
    
/* BN - FAQ: one answer open at a time; skin type pills filter the questions */
(function () {
  function init(root) {
    if (root.dataset.mxFaqReady) return;
    root.dataset.mxFaqReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mx-faq-item]'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-mx-faq-filter]'));

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    // same timing as the PDP accordion: open eases out, close eases in and out
    var easeOpen = 'cubic-bezier(0.33, 1, 0.68, 1)';
    var easeClose = 'cubic-bezier(0.65, 0, 0.35, 1)';

    /*
      The whole item slides between its open height and its question alone, and the answer fades.
      Sliding the item rather than the answer means its margin and the item's own padding never
      hold the close short and then drop at the end.
    */
    function setOpen(item, open, instant) {
      var toggle = item.querySelector('[data-mx-faq-toggle]');
      if (!toggle) return;
      var answer = document.getElementById(toggle.getAttribute('aria-controls'));
      var wasOpen = item.classList.contains('is-open') || !!item.mxFaqAnim;

      item.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!answer) return;

      if (instant || !item.animate || item.hidden || (reduce && reduce.matches) || open === wasOpen && !item.mxFaqAnim) {
        if (item.mxFaqAnim) { item.mxFaqAnim.cancel(); item.mxFaqFade.cancel(); item.mxFaqAnim = null; }
        answer.hidden = !open;
        return;
      }

      // a click mid slide starts from wherever the item has got to
      var from = item.getBoundingClientRect().height;
      var fromOpacity = answer.hidden ? 0 : parseFloat(getComputedStyle(answer).opacity);
      if (item.mxFaqAnim) { item.mxFaqAnim.cancel(); item.mxFaqFade.cancel(); }

      var to;
      if (open) {
        answer.hidden = false;
        to = item.getBoundingClientRect().height;
      } else {
        var answerSpace = answer.getBoundingClientRect().height + (parseFloat(getComputedStyle(answer).marginTop) || 0);
        to = item.getBoundingClientRect().height - answerSpace;
      }

      if (from === to) {
        answer.hidden = !open;
        item.mxFaqAnim = null;
        return;
      }

      var duration = Math.min(560, Math.max(300, Math.abs(to - from) * 1.2));

      item.style.overflow = 'hidden';
      // fill: forwards holds the last frame until done() runs, so nothing flashes at the end
      var anim = item.animate([{ height: from + 'px' }, { height: to + 'px' }], {
        duration: duration,
        easing: open ? easeOpen : easeClose,
        fill: 'forwards',
      });
      var fade = answer.animate([{ opacity: fromOpacity }, { opacity: open ? 1 : 0 }], {
        duration: open ? duration : duration * 0.75,
        easing: 'ease',
        fill: 'forwards',
      });

      item.mxFaqAnim = anim;
      item.mxFaqFade = fade;

      anim.onfinish = function () {
        item.mxFaqAnim = null;
        if (!open) answer.hidden = true;
        item.style.overflow = '';
        anim.cancel();
        fade.cancel();
      };
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-mx-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        items.forEach(function (other) { if (other !== item && other.classList.contains('is-open')) setOpen(other, false); });
        setOpen(item, open);
      });
    });

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var type = pill.getAttribute('data-mx-faq-filter');
        pills.forEach(function (p) {
          p.classList.toggle('is-active', p === pill);
          p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
        });
        items.forEach(function (item) {
          var types = item.getAttribute('data-types');
          var show = !type || !types || types.split('|').indexOf(type) > -1;
          item.hidden = !show;
          if (!show) setOpen(item, false, true);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mx-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-faq]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-feel-right"] && !Shopify.designMode) return;
  try {
    
/* BN - Feel Right (Figma prototype): desktop keeps one card open; clicking the open card opens the next one
   (both resize at the same time). Mobile: tapping the open card closes it, tapping a closed card opens it. */
(function () {
  function init(root) {
    if (root.dataset.mxFrReady) return;
    root.dataset.mxFrReady = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mx-fr-card]'));
    if (!cards.length) return;

    var MOBILE = '(max-width: 899px)';

    function open(index) {
      cards.forEach(function (card, i) {
        var on = i === index;
        card.classList.toggle('is-active', on);
        var toggle = card.querySelector('[data-mx-fr-toggle]');
        var body = card.querySelector('[data-mx-fr-body]');
        if (toggle) toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (body) body.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        if (!card.classList.contains('is-active')) {
          open(i);
        } else if (window.matchMedia(MOBILE).matches) {
          open(-1);
        } else if (cards.length > 1) {
          open((i + 1) % cards.length);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mx-fr]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-fr]');
    if (root) init(root);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('[data-mx-fr-card]');
    if (card && !card.classList.contains('is-active')) card.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-formulated"] && !Shopify.designMode) return;
  try {
    
/* BN - Formulated: open / close the In Vivo drawer (X, outside click, Esc) */
(function () {
  function init(root) {
    if (root.dataset.mxCfReady) return;
    root.dataset.mxCfReady = 'true';

    var overlay = root.querySelector('[data-mx-cf-overlay]');
    var drawer = root.querySelector('[data-mx-cf-drawer]');
    if (!overlay || !drawer) return;
    var opener = null;

    /* The section has its own stacking context (z-index), so the fixed drawer lives in <body> */
    overlay.setAttribute('data-mx-cf-owner', root.id);
    document.body.appendChild(overlay);

    function open(e) {
      opener = e && e.currentTarget;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var close = overlay.querySelector('[data-mx-cf-close]');
      if (close) close.focus({ preventScroll: true });
    }

    function close() {
      if (!overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (opener) opener.focus({ preventScroll: true });
    }

    root.querySelectorAll('[data-mx-cf-open]').forEach(function (b) { b.addEventListener('click', open); });
    overlay.querySelectorAll('[data-mx-cf-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', function (e) {
      if (!drawer.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mx-cf]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor: remove the moved drawer of a section that is re-rendered or removed */
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-mx-cf]');
    if (!root) return;
    document.querySelectorAll('[data-mx-cf-owner="' + root.id + '"]').forEach(function (el) { el.remove(); });
    document.documentElement.style.overflow = '';
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-cf]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-hear-it-from-them"] && !Shopify.designMode) return;
  try {
    
/* BN - Hear It From Them: infinite centered slider, active card plays video */
(function () {
  function px(el, name) {
    return parseFloat(getComputedStyle(el).getPropertyValue(name)) || 0;
  }

  function init(root) {
    if (root.dataset.mxHitfReady) return;
    root.dataset.mxHitfReady = 'true';

    var viewport = root.querySelector('[data-mx-hitf-viewport]');
    var track = root.querySelector('[data-mx-hitf-track]');
    var originals = Array.prototype.slice.call(root.querySelectorAll('[data-mx-hitf-card]'));
    var n = originals.length;
    if (!viewport || !track || !n) return;

    /* Clone the set on both sides so the loop never runs out of cards on screen */
    var copies = Math.max(1, Math.ceil(8 / n));
    function makeClone(card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      return clone;
    }
    for (var c = 0; c < copies; c++) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.forEach(function (card) {
        before.appendChild(makeClone(card));
        after.appendChild(makeClone(card));
      });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
    }

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-mx-hitf-card]'));
    var start = copies * n;
    var active = start + Math.floor(n / 2);

    /* Every video plays on its own without sound; only the sound is turned off again here */
    function eachVideo(fn) {
      cards.forEach(function (card) {
        var video = card.querySelector('[data-mx-hitf-video]');
        if (video) fn(video, card);
      });
    }

    function playAll() {
      eachVideo(function (video) {
        video.muted = video.muted !== false;
        if (video.paused) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    }

    function pauseAll() {
      eachVideo(function (video) { if (!video.paused) video.pause(); });
    }

    function muteAll() {
      eachVideo(function (video, card) {
        video.muted = true;
        card.classList.remove('is-playing');
      });
    }

    function position() {
      var cardW = px(root, '--mx-hitf-card-w');
      var activeW = px(root, '--mx-hitf-active-w');
      var gap = px(root, '--mx-hitf-gap');
      var activeCenter = active * (cardW + gap) + activeW / 2;
      track.style.transform = 'translateX(' + (viewport.clientWidth / 2 - activeCenter) + 'px)';
    }

    function paint() {
      cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === active);
      });
      position();
    }

    /* After sliding into a cloned area, jump back to the same card in the middle set without animation */
    function normalize() {
      if (active >= start && active < start + n) return;
      active = start + (((active - start) % n) + n) % n;
      root.classList.add('is-jumping');
      paint();
      void track.offsetWidth;
      root.classList.remove('is-jumping');
    }

    function goTo(index) {
      muteAll();
      active = index;
      paint();
      playAll();
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target === track && e.propertyName === 'transform') normalize();
    });

    /* Click the card in front: sound on (and off again). The video itself keeps playing */
    function toggleSound(card) {
      var video = card.querySelector('[data-mx-hitf-video]');
      if (!video) return;
      if (video.muted) {
        muteAll();
        video.muted = false;
        card.classList.add('is-playing');
      } else {
        video.muted = true;
        card.classList.remove('is-playing');
      }
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () { video.muted = true; video.play(); });
      }
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        if (i !== active) {
          goTo(i);
          return;
        }
        toggleSound(card);
      });
    });

    var prev = root.querySelector('[data-mx-hitf-prev]');
    var next = root.querySelector('[data-mx-hitf-next]');
    if (prev) prev.addEventListener('click', function () { normalize(); goTo(active - 1); });
    if (next) next.addEventListener('click', function () { normalize(); goTo(active + 1); });

    var startX = null;
    var startY = null;
    viewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        normalize();
        goTo(dx < 0 ? active + 1 : active - 1);
      }
      startX = null;
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        root.classList.add('is-jumping');
        position();
        void track.offsetWidth;
        root.classList.remove('is-jumping');
      }, 100);
    });

    root.classList.add('is-jumping');
    paint();
    void track.offsetWidth;
    root.classList.remove('is-jumping');

    /* All videos play without sound; they pause while the section is off screen or in a background tab */
    playAll();
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseAll(); else playAll();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) playAll(); else pauseAll();
      }, { threshold: 0.1 }).observe(root);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mx-hitf]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-hitf]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-key-ingredients"] && !Shopify.designMode) return;
  try {
    
/* BN - Key Ingredients: switch ingredient (list click, arrows, swipe) and the "All ingredient list" popup */
(function () {
  var MOBILE = '(max-width: 899px)';

  function init(root) {
    if (root.dataset.mxKiReady) return;
    root.dataset.mxKiReady = 'true';

    function all(sel) {
      return Array.prototype.slice.call(root.querySelectorAll(sel));
    }

    var items = all('[data-mx-ki-item]');
    var bgs = all('[data-mx-ki-bg]');
    var cards = all('[data-mx-ki-card]');
    var dots = all('[data-mx-ki-dot]');
    var n = cards.length;
    if (!n) return;

    var active = Math.max(0, cards.findIndex(function (c) { return c.classList.contains('is-active'); }));
    var leaveTimer = null;

    function goTo(index) {
      index = (index + n) % n;
      if (index === active) return;
      var leaving = cards[active];
      cards.forEach(function (el) { el.classList.remove('is-leaving'); });
      leaving.classList.add('is-leaving');
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(function () {
        leaving.classList.remove('is-leaving');
      }, window.matchMedia(MOBILE).matches ? 520 : 1650);
      active = index;
      items.forEach(function (el, i) {
        el.classList.toggle('is-active', i === active);
        el.setAttribute('aria-pressed', i === active ? 'true' : 'false');
      });
      bgs.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
      dots.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
      cards.forEach(function (el, i) {
        el.classList.toggle('is-active', i === active);
        el.setAttribute('aria-hidden', i === active ? 'false' : 'true');
      });
    }

    items.forEach(function (el, i) {
      el.addEventListener('click', function () { goTo(i); });
    });
    all('[data-mx-ki-prev]').forEach(function (b) { b.addEventListener('click', function () { goTo(active - 1); }); });
    all('[data-mx-ki-next]').forEach(function (b) { b.addEventListener('click', function () { goTo(active + 1); }); });

    var visual = root.querySelector('[data-mx-ki-visual]');
    var startX = null;
    var startY = null;
    if (visual) {
      visual.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      visual.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goTo(dx < 0 ? active + 1 : active - 1);
        startX = null;
      }, { passive: true });
    }

    var popup = root.querySelector('[data-mx-ki-popup]');
    var card = root.querySelector('[data-mx-ki-popup-card]');
    var opener = null;

    function openPopup(e) {
      if (!popup) return;
      opener = e && e.currentTarget;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      if (window.matchMedia(MOBILE).matches) document.documentElement.style.overflow = 'hidden';
      var close = popup.querySelector('[data-mx-ki-close]');
      if (close) close.focus({ preventScroll: true });
    }

    function closePopup() {
      if (!popup || !popup.classList.contains('is-open')) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (opener) opener.focus({ preventScroll: true });
    }

    all('[data-mx-ki-open]').forEach(function (b) { b.addEventListener('click', openPopup); });
    all('[data-mx-ki-close]').forEach(function (b) { b.addEventListener('click', closePopup); });
    if (popup) {
      popup.addEventListener('click', function (e) {
        if (card && !card.contains(e.target)) closePopup();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    /* No link set: let an AI chat widget listen for this event */
    all('[data-mx-ki-ask]').forEach(function (b) {
      b.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('mx:ask-ai', { detail: { topic: 'ingredients', source: root.id } }));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mx-ki]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-ki]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-next-essentials"] && !Shopify.designMode) return;
  try {
    
/* BN - Next Essentials: arrows scroll the row a card at a time; AJAX add to cart into the theme cart drawer */
(function () {
  function initSlider(root) {
    var row = root.querySelector('[data-mx-nse-row]');
    var prev = root.querySelector('[data-mx-nse-prev]');
    var next = root.querySelector('[data-mx-nse-next]');
    if (!row || !prev || !next) return;

    function step() {
      var card = row.querySelector('.mx-nse__card');
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : row.clientWidth;
    }

    // the row's right padding is only there to let the next card peek, so the end is one padding early
    function maxScroll() {
      var pad = parseFloat(getComputedStyle(row).paddingRight) || 0;
      return row.scrollWidth - row.clientWidth - pad;
    }

    function sync() {
      var end = maxScroll();
      var fits = end <= 2;
      prev.hidden = fits;
      next.hidden = fits;
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= end - 2;
    }

    prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });

    var ticking = false;
    row.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initCart(root) {
    root.querySelectorAll('[data-mx-nse-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var button = form.querySelector('[type="submit"]');
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!button || !window.fetch) return;
        e.preventDefault();
        if (button.classList.contains('is-loading')) return;
        button.classList.add('is-loading');

        var data = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          data.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        fetch(form.action, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: data
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) {
              /* e.g. not enough stock: show the message on the button */
              button.querySelector('.mx-nse__button-text').textContent = response.description || response.message || 'Error';
              return;
            }
            if (!cart || typeof cart.renderContents !== 'function') {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }
            /* Theme pub/sub (PUB_SUB_EVENTS is a global const, not a window property) */
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mx-nse', productVariantId: data.get('id') });
            }
            cart.renderContents(response);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            button.classList.remove('is-loading');
          });
      });
    });
  }

  function init(root) {
    if (root.dataset.mxNseReady) return;
    root.dataset.mxNseReady = 'true';
    initSlider(root);
    initCart(root);
  }

  function initAll() {
    document.querySelectorAll('[data-mx-nse]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-nse]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-science-of-milk"] && !Shopify.designMode) return;
  try {
    
/* BN - Science Of Milk (Figma prototype, driven by scroll):
   - Entry: desktop on mouse enter or when 40% is on screen, mobile when it scrolls into view (CSS transitions).
   - Scroll: the section pins; the page scroll picks the step and the row slides to it with the Figma
     transition (CSS, 1.3s desktop / 1.6s mobile). After the last step the page carries on.
   - Desktop: the 1440 x 1000 frame is scaled to fit the screen; clicking a card scrolls to the next / previous step.
   - Mobile: tapping a card scrolls to the next card. */
(function () {
  var desktop = window.matchMedia('(min-width: 900px)');
  /* Figma frame used on desktop: 1440 wide, cropped to 1000 tall (the cards end at 910) */
  var FRAME_W = 1440;
  var FRAME_H = 1000;
  /* page scroll per step, as a share of the screen height */
  var STEP_SCROLL = 0.8;

  function init(root) {
    if (root.dataset.mxSomReady) return;
    root.dataset.mxSomReady = 'true';

    var sticky = root.querySelector('[data-mx-som-sticky]');
    var track = root.querySelector('[data-mx-som-track]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-mx-som-step]'));
    if (!sticky || !track || !steps.length) return;

    var pin = steps.length > 1;
    if (pin) root.classList.add('mx-som--pin');

    /* measured in layout(): scale, pinned box top and height, scroll range (screen px) */
    var scale = 1;
    var top = 0;
    var boxH = 0;
    var scrollRange = 0;
    var active = -1;

    function layout() {
      var vw = sticky.clientWidth;
      var vh = window.innerHeight;

      if (desktop.matches) {
        scale = pin ? Math.min(vw / FRAME_W, vh / FRAME_H) : vw / FRAME_W;
        root.style.setProperty('--mx-som-scale', String(scale));
        root.style.setProperty('--mx-som-vh', vh + 'px');
        root.style.setProperty('--mx-som-x', Math.max(0, (vw - FRAME_W * scale) / 2) + 'px');
        root.style.setProperty('--mx-som-y', Math.max(0, (vh - FRAME_H * scale) / 2) + 'px');
        top = 0;
        boxH = vh;
      } else {
        scale = 1;
        root.style.setProperty('--mx-som-scale', '1');
        boxH = sticky.offsetHeight;
        /* stick with the bottom of the box at the bottom of the screen, but never push the cards' top off it */
        var viewport = root.querySelector('[data-mx-som-viewport]');
        var cardsTop = viewport ? viewport.offsetTop : 0;
        top = Math.min(0, Math.max(vh - boxH, 16 - cardsTop));
        root.style.setProperty('--mx-som-top', top + 'px');
      }

      scrollRange = pin ? (steps.length - 1) * vh * STEP_SCROLL : 0;
      root.style.height = pin ? boxH + scrollRange + 'px' : '';
      /* re-place the row for the new size */
      var current = active;
      active = -1;
      goTo(current < 0 ? 0 : current);
      update();
    }

    /* Slide the row so step `index` sits at the start position (x = 56 in Figma px on desktop).
       The track's CSS transition plays the Figma Smart Animate (sun -> milk). */
    function goTo(index) {
      index = Math.min(steps.length - 1, Math.max(0, index));
      if (index === active) return;
      active = index;
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === active);
      });
      /* offsetLeft is in track px (before the desktop scale) */
      var shift = steps[active].offsetLeft - steps[0].offsetLeft;
      track.style.transform = 'translate3d(' + -shift + 'px, 0, 0)';
    }

    /* The scroll range is split into one equal part per step */
    function update() {
      if (!pin) return;
      var p = scrollRange > 0 ? (top - root.getBoundingClientRect().top) / scrollRange : 0;
      p = Math.min(1, Math.max(0, p));
      goTo(Math.min(steps.length - 1, Math.floor(p * steps.length)));
    }

    /* Scroll the page to the middle of step `index`'s part of the range */
    function scrollToStep(index) {
      if (!pin) return;
      index = Math.min(steps.length - 1, Math.max(0, index));
      var p = (index + 0.5) / steps.length;
      var rootTop = root.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: rootTop - top + p * scrollRange, behavior: 'smooth' });
    }

    /* Desktop: a card on the right half of the screen goes to the next step, on the left half to the previous */
    track.addEventListener('click', function (e) {
      if (!pin) return;
      if (desktop.matches) {
        var card = e.target.closest('.mx-som__card, .mx-som__visual--card');
        if (!card) return;
        var rect = card.getBoundingClientRect();
        var box = sticky.getBoundingClientRect();
        var forward = rect.left + rect.width / 2 >= box.left + box.width / 2;
        scrollToStep(active + (forward ? 1 : -1));
      } else if (e.target.closest('.mx-som__card')) {
        scrollToStep(active + 1);
      }
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });

    window.addEventListener('resize', layout);
    if (desktop.addEventListener) desktop.addEventListener('change', layout);
    /* images and fonts change the mobile box height */
    window.addEventListener('load', layout);

    /* Fade-in (Figma state 1 -> 2). Content is visible by default; it is only hidden once JS runs. */
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduceMotion) {
      root.classList.add('mx-som--animate');
      var show = function () {
        root.classList.add('is-visible');
        io.disconnect();
      };
      /* Desktop: Figma trigger is mouse enter; fallback when 40% of the section is on screen */
      root.addEventListener('mouseenter', function () { if (desktop.matches) show(); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!desktop.matches || entry.intersectionRatio >= 0.4) show();
        });
      }, { threshold: [0.15, 0.4] });
      io.observe(sticky);
    }

    layout();
  }

  function initAll() {
    document.querySelectorAll('[data-mx-som]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-som]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-sticky-bar"] && !Shopify.designMode) return;
  try {
    
/* BN - Sticky Bar: show after the product title, follow the header, scroll links, variant / quantity, AJAX add to bag */
(function () {
  function headerBottom() {
    var header = document.querySelector('.section-header') || document.querySelector('sticky-header') || document.querySelector('header');
    if (!header) return 0;
    var r = header.getBoundingClientRect();
    return r.bottom > 0 ? r.bottom : 0;
  }

  function findTarget(target) {
    if (!target) return null;
    var el = null;
    if (target.charAt(0) === '#' || target.charAt(0) === '.') {
      try { el = document.querySelector(target); } catch (e) { el = null; }
    } else {
      el = document.querySelector('[id^="shopify-section-"][id$="__' + target + '"]');
    }
    /* Hidden when the section rendered nothing (no data for this product) */
    if (!el || el.offsetHeight < 2) return null;
    return el;
  }

  function init(root) {
    if (root.dataset.mxSbReady) return;
    root.dataset.mxSbReady = 'true';

    var bar = root.querySelector('.mx-sb__bar');
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-mx-sb-link]'));
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-mx-sb-variants]').textContent); } catch (e) {}

    /* Links: keep only the ones whose section has content */
    function refreshLinks() {
      links.forEach(function (a) { a.hidden = !findTarget(a.getAttribute('data-target')); });
    }
    refreshLinks();
    window.addEventListener('load', refreshLinks);

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var el = findTarget(a.getAttribute('data-target'));
        if (!el) return;
        var offset = headerBottom() + (window.matchMedia('(max-width: 899px)').matches ? root.querySelector('.mx-sb__links').offsetHeight : bar.offsetHeight);
        var y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    /* Active link: the last visible link whose section top has passed the bar (plus a small margin) */
    var linksRow = root.querySelector('.mx-sb__links');

    /* The scrollbar shows itself while the row is actually being scrolled, then fades back out */
    var scrollRest;
    linksRow.addEventListener('scroll', function () {
      linksRow.classList.add('is-scrolling');
      clearTimeout(scrollRest);
      scrollRest = setTimeout(function () { linksRow.classList.remove('is-scrolling'); }, 700);
    });

    var activeLink = null;
    function spy(line) {
      var current = null;
      links.forEach(function (a) {
        if (a.hidden) return;
        var el = findTarget(a.getAttribute('data-target'));
        if (!el) return;
        var r = el.getBoundingClientRect();
        if (r.top <= line + 24 && r.bottom > line) current = a;
      });
      if (current === activeLink) return;
      if (activeLink) activeLink.classList.remove('is-active');
      activeLink = current;
      if (!current) {
        links.forEach(function (a) { a.removeAttribute('aria-current'); });
        return;
      }
      current.classList.add('is-active');
      links.forEach(function (a) { if (a === current) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      /* Slide the links row so the active link is visible (mobile / narrow screens) */
      var rowRect = linksRow.getBoundingClientRect();
      var aRect = current.getBoundingClientRect();
      if (aRect.left < rowRect.left + 16 || aRect.right > rowRect.right - 16) {
        linksRow.scrollTo({ left: linksRow.scrollLeft + (aRect.left - rowRect.left) - 16, behavior: 'smooth' });
      }
    }

    /* Show once the hero has scrolled up out of view (see getTrigger) */
    /* The main section renders some blocks twice (desktop / mobile copies); only a copy that is on screen counts */
    function visibleFirst(selector) {
      var list = document.querySelectorAll(selector);
      for (var i = 0; i < list.length; i++) {
        if (list[i].getClientRects().length && list[i].offsetHeight > 0) return list[i];
      }
      return null;
    }
    /*
      Client request: the bar waits until the whole hero (gallery + info column) has scrolled away and the
      sections below start, instead of appearing while the gallery / info column are still scrolling.
      The trigger is the main product section's wrapper; the older triggers stay as fallbacks.
    */
    function getTrigger() {
      var hero = document.querySelector('.product.mx-pdp');
      if (hero) return hero.closest('.shopify-section') || hero;
      return visibleFirst('[id^="MainProduct-"] .product-form__submit') ||
        visibleFirst('[id^="ProductSubmitButton-"]') ||
        visibleFirst('.product__title') ||
        visibleFirst('[id^="MainProduct-"]');
    }
    var ticking = false;
    function update() {
      ticking = false;
      var top = headerBottom();
      root.style.setProperty('--mx-sb-top', top + 'px');
      var trigger = getTrigger();
      var show = trigger ? trigger.getBoundingClientRect().bottom < top : window.pageYOffset > window.innerHeight;
      root.classList.toggle('is-visible', show);
      /*
        The buy bar is on screen the whole time on a phone, so the bar itself is never announced
        as hidden there; only the links strip, which is what actually comes and goes.
      */
      var onPhone = window.matchMedia('(max-width: 899px)').matches;
      root.setAttribute('aria-hidden', show || onPhone ? 'false' : 'true');
      linksRow.setAttribute('aria-hidden', show ? 'false' : 'true');
      var barHeight = window.matchMedia('(max-width: 899px)').matches ? linksRow.offsetHeight : bar.offsetHeight;
      spy(top + barHeight);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Variant + quantity */
    var form = root.querySelector('[data-mx-sb-form]');
    var idInput = root.querySelector('[data-mx-sb-id]');
    var select = root.querySelector('[data-mx-sb-select]');
    var qty = root.querySelector('[data-mx-sb-qty]');
    var addBtn = root.querySelector('[data-mx-sb-add]');
    var addLabel = root.querySelector('[data-mx-sb-add-label]');
    var labels = { add: root.getAttribute('data-add-label'), soldOut: root.getAttribute('data-sold-out-label'), off: root.getAttribute('data-off-label') };

    function applyVariant(id, available) {
        var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        if (typeof available === 'boolean') v.available = available;
        if (select) select.value = String(v.id);
        idInput.value = v.id;
        root.querySelectorAll('[data-mx-sb-title]').forEach(function (n) { n.textContent = v.title; });
        root.querySelectorAll('[data-mx-sb-price]').forEach(function (n) { n.textContent = v.price; });
        root.querySelectorAll('[data-mx-sb-compare]').forEach(function (n) { n.textContent = v.compare || ''; n.hidden = !v.compare; });
        var off = root.querySelector('[data-mx-sb-off]');
        if (off) { off.hidden = !(v.off > 0); off.textContent = v.off + '% ' + labels.off; }
        var thumb = root.querySelector('[data-mx-sb-thumb]');
        if (thumb && v.image) thumb.src = v.image;
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? labels.add : labels.soldOut;
    }

    if (select) {
      select.addEventListener('change', function () { applyVariant(select.value); });
    }

    /* Follow the main product variant (theme pub/sub event, and the main form's variant input) */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event && event.data && event.data.variant;
        if (v && v.id) applyVariant(v.id, v.available);
      });
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'id' || root.contains(t)) return;
      if (t.closest('[id^="product-form-"]') || t.closest('[id^="MainProduct-"]')) applyVariant(t.value);
    });

    /* The bar and the product form share one number, so it does not matter which one is used */
    function mainNode(selector) {
      var node = document.querySelector('.product-form_wrapper ' + selector);
      return node && !root.contains(node) ? node : null;
    }

    function setQty(n, fromMain) {
      qty.value = Math.max(1, parseInt(n, 10) || 1);
      if (fromMain) return;
      var main = mainNode('.quantity__input');
      if (main && String(main.value) !== String(qty.value)) {
        main.value = qty.value;
        main.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    root.querySelector('[data-mx-sb-minus]').addEventListener('click', function () { setQty(parseInt(qty.value, 10) - 1); });
    root.querySelector('[data-mx-sb-plus]').addEventListener('click', function () { setQty(parseInt(qty.value, 10) + 1); });
    qty.addEventListener('change', function () { setQty(qty.value); });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('quantity__input') || root.contains(t)) return;
      setQty(t.value, true);
    });

    /* Add to bag: same flow as the theme product form (cart drawer / notification) */
    form.addEventListener('submit', function (e) {
      if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;

      /*
        When the product form is on the page, the bar hands the job to it instead of posting a
        cart of its own. That way the quantity, the chosen variant, the selling plan and every
        error the theme knows how to show all come from one place.
      */
      var mainAdd = mainNode('.product-form-cta .product-form__submit');
      if (mainAdd && !mainAdd.disabled) {
        e.preventDefault();
        setQty(qty.value);
        mainAdd.click();
        return;
      }

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!window.fetch) return;
      e.preventDefault();
      addBtn.classList.add('is-loading');
      var data = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        data.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      fetch(form.action, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            addLabel.textContent = response.description || response.message || labels.soldOut;
            return;
          }
          if (!cart || typeof cart.renderContents !== 'function') {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mx-sb', productVariantId: data.get('id') });
          }
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        })
        .catch(function () { form.submit(); })
        .finally(function () { addBtn.classList.remove('is-loading'); });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mx-sb]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-sb]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-timeline"] && !Shopify.designMode) return;
  try {
    
/* BN - Timeline: tap / click the section to move to the next step; tap a step to jump to it */
(function () {
  function init(root) {
    if (root.dataset.mxTlReady) return;
    root.dataset.mxTlReady = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-mx-tl-step]'));
    if (steps.length < 2) return;
    var current = 0;

    function goTo(index) {
      current = Math.max(0, Math.min(steps.length - 1, index));
      steps.forEach(function (step, i) {
        step.classList.toggle('is-done', i <= current);
        step.classList.toggle('is-current', i === current);
      });
    }

    /* Desktop and mobile (client request): click a step to jump to it, anywhere else for the next one */
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-mx-tl-step]');
      var index = step ? steps.indexOf(step) : -1;
      if (index > -1 && index !== current) goTo(index);
      else if (current < steps.length - 1) goTo(current + 1);
    });

    goTo(0);

    /*
      Mobile only (client request): the timeline follows the scroll. The step whose week pill has
      come up past the middle of the screen is the current one, so scrolling down opens Week 4 and
      shuts Week 1, and scrolling back up opens Week 1 again. A tap still jumps to a step; the
      scroll only takes over again once it actually moves the current step somewhere new.
    */
    var mobile = window.matchMedia('(max-width: 899px)');
    var heads = steps.map(function (step) { return step.querySelector('.mx-tl__head') || step; });
    var lastScrolled = 0;
    var ticking = false;

    /*
      Two lines rather than one, so a pill resting right on the line cannot flick the step back
      and forth: a step opens once its pill rises past 45% of the screen, and the one before it
      only comes back once that pill drops below 65%.
    */
    function fromScroll() {
      ticking = false;
      if (!mobile.matches) return;
      var h = window.innerHeight;
      var index = 0;
      for (var i = 1; i < heads.length; i++) {
        var top = heads[i].getBoundingClientRect().top;
        var line = i <= current ? h * 0.65 : h * 0.45;
        if (top <= line) index = i;
      }
      if (index === lastScrolled) return;
      lastScrolled = index;
      if (index !== current) goTo(index);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(fromScroll);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (mobile.addEventListener) {
      mobile.addEventListener('change', function () {
        if (!mobile.matches) return;
        lastScrolled = -1;
        onScroll();
      });
    }
    onScroll();
  }

  function initAll() {
    document.querySelectorAll('[data-mx-tl]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mx-tl]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    let bundleItems = document.querySelectorAll('.discounts__discount span');

    bundleItems.forEach(bundleItem => {
      console.log('Checking:', bundleItem.innerHTML.trim());

      if (bundleItem.innerHTML.trim() === 'BUNDLE') {
        let cartItem = bundleItem.closest('.cart-item');
        console.log('Found cart item:', cartItem);

        if (cartItem) {
          let qtyInput = cartItem.querySelector('.cart-item__quantity-wrapper');
          console.log('Found qtyInput:', qtyInput);

          if (qtyInput) {
            //qtyInput.style.display = 'none';
            qtyInput.classList.add('hidden');
            console.log('Hiding qtyInput');
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
